import { Bouton, GroupeBouton } from '@design-system-etat/dsfr-react';
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import RoutesRepriseDonnees from './CorrigerArme/routes';
import { getPath } from '../../../../../../utils/router';

const BoutonsAction = ({ handleClickAfficherModal, repriseDeDonneesUuid }) => {
    const handleClickButton = () => {
        handleClickAfficherModal(repriseDeDonneesUuid);
    };

    const urlModifierArme = getPath(RoutesRepriseDonnees, {
        uuidArmeSelec: repriseDeDonneesUuid,
    });

    return (
        <GroupeBouton alignementHorizontal="right" isHorizontal>
            <Link className="fr-nav" to={urlModifierArme}>
                <Bouton
                    label="Complément ou correction"
                    icone="fr-fi-edit-line"
                    niveau="secondaire"
                />
            </Link>
            <Bouton
                label="Suppression"
                icone="fr-fi-delete-line"
                niveau="secondaire"
                onClick={handleClickButton}
            />
        </GroupeBouton>
    );
};

BoutonsAction.propTypes = {
    handleClickAfficherModal: PropTypes.func.isRequired,
    repriseDeDonneesUuid: PropTypes.string.isRequired,
};

export default BoutonsAction;
